import React, { useContext, useEffect, useRef, useState } from 'react'
import { findIndex, isEmpty, get, uniqueId, map, isEqual } from 'lodash'
import BookPage from './page'
import {useScroll} from 'react-use';
import { BookInfo } from '../../contexts/menuContext'
import { getPages } from '../../api/getPage'

const BookContent = ({ navArray }) => {
  const [book, setBook, page, setPage, forceScroll, setForceScroll] = useContext(BookInfo)
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const ref = useRef();
  const BookRef = useRef(null);
  const {y} = useScroll(BookRef);
  const [position, setPosition] = useState(0);
  const [requested, setRequested] = useState('')
  const preparedNavArray = navArray.filter((i) => get(i, 'url'))
  const index = findIndex(preparedNavArray, (item) => {
    return item.id === page;
  });
  const preparedNonNavArray = navArray.filter((i) => !get(i, 'url'))
  const render = preparedNavArray.filter((item, i) => {
    const { length } = navArray
    const arr = [
      index - 4 >= 0 ? index - 4 : -1,
      index - 3 >= 0 ? index - 3 : -1,
      index - 2 >= 0 ? index - 2 : -1,
      index - 1 >= 0 ? index - 1 : -1,
      index,
      index+1 <= length-1 ? index+1 : -1,
      index+2 <= length-1 ? index+2: -1,
      index+3 <= length-1 ? index+3 : -1,
      index+4 <= length-1 ? index+4 : -1]
    return arr.filter(element => {return element >= 0 || !isEmpty(element)}).includes(i)
  });
  useEffect(() => {
    if (!isEmpty(page) && content.length) {
      const pagePos = document.querySelector(`#p_${page}`);
      const topPos = pagePos?.offsetTop
        - document.querySelector('.control-wrapper').offsetHeight
        - document.querySelector('.bookreader-mobile-mobile-nav').offsetHeight
      const hight = document.querySelector('.book').scrollTop + document.querySelector(`#p_${page} span[style*="background-color"]`)?.getBoundingClientRect().top - 300
      if (topPos >= 0 && (forceScroll || firstRender)) {
        document.querySelector('.book').scrollTop = hight ? hight : topPos
        setFirstRender(false)
        if (topPos > 0 ) {
          setForceScroll(false)
        }
      }
    }
    // eslint-disable-next-line
  }, [page, forceScroll, content])

  const scroll = (scrollPage) => {
    if (!isEmpty(scrollPage)) {
      const topPos = document.querySelector(`#p_${scrollPage}`)?.offsetTop
        - document.querySelector('.control-wrapper').offsetHeight
        - document.querySelector('.bookreader-mobile-mobile-nav').offsetHeight
      document.querySelector('.book').scrollTop = topPos
      if (topPos > 0 ) {
        setForceScroll(false)
      }
    }
  }

  const setRequestedContent = (data) => {
    // const preparedContent = render.map((item) => {
    //   return data.find(i => i.id === item.id);
    // })
    setContent(data.filter(item => {return item}));
    setLoading(false);
    // return preparedContent;
  }
  const getPageStatic = preparedNonNavArray.filter((renderItem) => {return isEmpty(get(renderItem, 'url'))});
  const stat = getPageStatic.map(item => {
    return {content:{body: get(book, `content[${item.id}]`)}, title: get(item, 'title', ''), id: item.id}
  })
  useEffect(() => {
    const indexX = findIndex(content, (item) => {
      return get(item, 'id', 0) === page
    })
    if (index === -1) {
      const req = preparedNavArray.slice(0, 5)
      const equal = isEqual(map(content, 'id'), map(req, 'id'))
      if (!equal) {
        getPages(map(req, 'id')).then((data) => {
          setLoading(true)
          setForceScroll(false)
          setRequestedContent([...data])
        })
      }
    }
    if (
      page &&
      index >= 0 &&
      !isEmpty(render) &&
      (indexX < 2 || indexX >= content.length - 2 || indexX === -1) || firstRender
    ) {
      const req = render.filter((renderItem) => {return get(renderItem, 'url')});
      if (JSON.stringify(req) !== requested) {
        setRequested(JSON.stringify(req))
        getPages(map(req, 'id')).then((data) => {
          setLoading(true)
          setForceScroll(false)
          setRequestedContent([...data])
          scroll(page)
          setBook({...book, updated: Date.now()})
        });
      }
    }
    // eslint-disable-next-line
  }, [page, navArray, position, content, index])
  // useEffect(() => {
  //   setForceScroll(true)
  // }, [menuStatus, rightSidebar])
  useEffect(() => {
    if (y - position > 100 || y - position < -100) {
      setPosition(y)
    }
  }, [y, position])

  useEffect(() => {
    if (!page && !isEmpty(navArray)) {
      setPage(navArray[0].id)
      setForceScroll(true)
    }
  }, [page, navArray])


  return (
    <div className="book" ref={BookRef}>
      <div className="statick-height">
        {get(book, 'page_type', '') === 'chapters' && index < 3 && stat.map((item, i) => {
          return (<div className="page-wrapp" key={i}>
            {item && <BookPage
              key={get(item, 'id', false) ? item.id : `rand_${uniqueId()}`}
              item={item}
              scrollRef={ref}
              position={position}
              loading={loading}
            />}
          </div>)
        })}
        {content.map((item, i) => {
          return (<div className="page-wrapp loaded-content" key={i}>
            {item && <BookPage
              key={get(item, 'id', false) ? item.id : `rand_${uniqueId()}`}
              item={item}
              loading={loading}
              scrollRef={ref}
              position={position}
              last={content.length - 1 === i}
              first={i === 0 && index - 1 > 0}
            />}
          </div>)
        })
        }

      </div>
    </div>
  )
}

export default BookContent
